<template>
    <div>
        <h1 style="font-size: 24px; color: black;">关键行为配置</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="广告主id（模糊）：">
                    <el-input v-model="queryData.advertiserIds" style="width:200px" clearable
                              placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="app应用：">
                    <el-select v-model="queryData.appId" placeholder="请选择" filterable>
                        <el-option
                            v-for="item in this.enum"
                            :key="item.appId"
                            :label="item.appName"
                            :value="item.appId">
                        </el-option>
                    </el-select>
                    <span style="position: relative; left:20px">
                     <el-button type="primary" @click="getList">查询</el-button>
                    </span>
                    <span style="position: relative; left:150px">
                         <el-button type="primary"
                                    @click="showSaveFormDialog('新增关键行为配置')">新增关键行为配置</el-button>
                    </span>
                </el-form-item>
            </el-form>
            <span style="position: relative; left:180px">
                         <el-button type="primary" @click="jump">监测链接地址生成</el-button>
                    </span>
        </el-card>
        <h1>
            <el-table border :data="list" :cell-style="cell">
                <!--                <el-table-column prop="id" label="编号" align="center"></el-table-column>-->
                <el-table-column prop="appId" label="应用" align="center" :formatter="enumFormatter"></el-table-column>
                <el-table-column prop="rule" label="策略" align="center" :formatter="ruleFormatter"></el-table-column>
                <el-table-column prop="acRule" label="激活策略" align="center" :formatter="acRuleFormatter"></el-table-column>
                <el-table-column prop="advertiserIds" label="广告主id" align="center"></el-table-column>
                <el-table-column prop="agentId" label="代理商" align="center"></el-table-column>
                <el-table-column prop="lcName" label="投放人员" align="center"></el-table-column>
                <!--                <el-table-column prop="maxEcpm" label="maxEcpm(低优先级)" align="center"></el-table-column>-->
                <el-table-column prop="ecpm" label="ecpm(关键行为)" align="center"></el-table-column>
                <el-table-column prop="ltv" label="ltv(关键行为)" align="center"></el-table-column>
                <el-table-column prop="ads" label="广告数(关键行为)" align="center"></el-table-column>
                <!--                <el-table-column prop="ecpmr1" label="ecpm(48)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="ltvr1" label="ltv(48)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="adsr1" label="广告数(48)" align="center"></el-table-column>-->

                <!--                <el-table-column prop="ecpmv" label="ecpm(激励视频激活扣量)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="maxEcpmv" label="maxEcpm(激励视频激活扣量)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="adsv" label="广告数(激励视频激活扣量)" align="center"></el-table-column>-->

                <!--                <el-table-column prop="ecpmi" label="ecpm(插屏激活扣量)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="maxEcpmi" label="maxEcpm(插屏激活扣量)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="adsi" label="广告数(插屏激活扣量)" align="center"></el-table-column>-->

                <!--                <el-table-column prop="ecpms" label="ecpm(开屏激活扣量)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="maxEcpms" label="maxEcpm(开屏激活扣量)" align="center"></el-table-column>-->
                <!--                <el-table-column prop="adss" label="广告数(开屏激活扣量)" align="center"></el-table-column>-->

                <el-table-column prop="ecpma" label="ecpm(激活扣量)" align="center"></el-table-column>
                <el-table-column prop="adsa" label="广告数(激活扣量)" align="center"></el-table-column>

                <el-table-column prop="ltva" label="ltv(激活扣量)" align="center"></el-table-column>

                <!--                <el-table-column prop="createDt" label="创建时间" align="center"></el-table-column>-->
                <!--                <el-table-column prop="updateDt" label="修改时间" align="center"></el-table-column>-->
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑配置',scope.row)">编辑
                        </el-button>
                        <!--                        <el-button type="text" @click="remove(scope.row)">删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1000px">
            <el-form :model="saveForm">
                <el-form-item label="投放人员"
                              :label-width="labelWidth">
                    <el-select v-model="saveForm.lcName" placeholder="请选择" filterable>
                        <el-option label="张瀛旭" value="张瀛旭"></el-option>
                        <el-option label="卓敏敏" value="卓敏敏"></el-option>
                        <el-option label="罗桦" value="罗桦"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="代理商"
                              :label-width="labelWidth">
                    <el-select v-model="saveForm.agentId" placeholder="请选择" filterable>
                        <el-option label="青澜" value="青澜"></el-option>
                        <el-option label="拓思" value="拓思"></el-option>
                        <el-option label="凯美" value="凯美"></el-option>
                        <el-option label="侠客行" value="侠客行"></el-option>
                        <el-option label="睿道" value="睿道"></el-option>
                        <el-option label="万圣" value="万圣"></el-option>
                        <el-option label="开域" value="开域"></el-option>
                        <el-option label="拓思" value="拓思"></el-option>
                        <el-option label="百度" value="百度"></el-option>
                        <el-option label="帧尚" value="帧尚"></el-option>
                        <el-option label="微电" value="微电"></el-option>
                    </el-select>
                </el-form-item>
                <h1>空白是广告激活</h1>
                <el-form-item label="策略"
                              :label-width="labelWidth">
                    <el-select v-model="saveForm.rule" placeholder="请选择">
                        <el-option v-for="(value, key) in ruleEnum"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-form-item>
                <h1>双出价不回传关键行为，空白是关键行为</h1>
                <el-form-item label="激活策略"
                              :label-width="labelWidth">
                    <el-select v-model="saveForm.acRule" placeholder="请选择">
                        <el-option v-for="(value, key) in acRuleEnum"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-form-item>
                <h1>小米secret_key需要严格按照格式填写，否则无法回传4.0，中间使用！英文！逗号分隔，中间不要有空格，格式 secret_key,app_id,资产id 例子 bgeoZAPbtYxyqMok,1563011,3202</h1>
                <el-form-item label="百度akey/小米secret_key/vivo事件源id"
                              :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.akey"></el-input>
                </el-form-item>
                <el-form-item label="广告主id使用','分割（整数和小写的,），0代表包下默认值"
                              :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.advertiserIds"></el-input>
                </el-form-item>
                <!--                <el-form-item label="maxEcpm（小数.）" :label-width="labelWidth">-->
                <!--                    <el-input type="text" v-model="saveForm.maxEcpm"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <el-form-item label="ecpm(关键行为)（小数.）" :label-width="labelWidth" style="background-color: #FFCCCC">
                    <el-input type="text" v-model="saveForm.ecpm"
                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="ltv(关键行为)（小数.）" :label-width="labelWidth" style="background-color: #FFCCCC">
                    <el-input type="text" v-model="saveForm.ltv"
                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="广告数(关键行为)（整数）" :label-width="labelWidth"
                              style="background-color: #FFCCCC">
                    <el-input type="text" v-model="saveForm.ads" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
                </el-form-item>
                <!--                <el-form-item label="ecpm(48)（小数.）" :label-width="labelWidth">-->
                <!--                    <el-input type="text" v-model="saveForm.ecpmr1"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="ltv(48)（小数.）" :label-width="labelWidth">-->
                <!--                    <el-input type="text" v-model="saveForm.ltvr1"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="广告数(48)（整数）" :label-width="labelWidth">-->
                <!--                    <el-input type="text" v-model="saveForm.adsr1"-->
                <!--                              oninput="value=value.replace(/[^0-9]/g,'')"></el-input>-->
                <!--                </el-form-item>-->

                <!--                <el-form-item label="ecpm(激励视频激活扣量)（小数.）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.ecpmv"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="maxEcpm(激励视频激活扣量)（小数.）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.maxEcpmv"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="广告数(激励视频激活扣量)（整数）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.adsv"-->
                <!--                              oninput="value=value.replace(/[^0-9]/g,'')"></el-input>-->
                <!--                </el-form-item>-->

                <!--                <el-form-item label="ecpm(插屏激活扣量)（小数.）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.ecpmi"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="maxEcpm(插屏激活扣量)（小数.）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.maxEcpmi"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="广告数(插屏激活扣量)（整数）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.adsi"-->
                <!--                              oninput="value=value.replace(/[^0-9]/g,'')"></el-input>-->
                <!--                </el-form-item>-->


                <!--                <el-form-item label="ecpm(开屏激活扣量)（小数.）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.ecpms"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="maxEcpm(开屏激活扣量)（小数.）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.maxEcpms"-->
                <!--                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="广告数(开屏激活扣量)（整数）" :label-width="labelWidth"-->
                <!--                              style="background-color: #CCFFCC">-->
                <!--                    <el-input type="text" v-model="saveForm.adss"-->
                <!--                              oninput="value=value.replace(/[^0-9]/g,'')"></el-input>-->
                <!--                </el-form-item>-->

                <el-form-item label="ecpm(激活扣量)（小数.）" :label-width="labelWidth"
                              style="background-color: #CCFFCC">
                    <el-input type="text" v-model="saveForm.ecpma"
                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="广告数(激活扣量)（整数）" :label-width="labelWidth"
                              style="background-color: #CCFFCC">
                    <el-input type="text" v-model="saveForm.adsa"
                              oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
                </el-form-item>

                <el-form-item label="ltv(激活扣量)（小数.）" :label-width="labelWidth" style="background-color: #CCFFCC">
                    <el-input type="text" v-model="saveForm.ltva"
                              oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>

                <el-form-item label="应用名称" :label-width="labelWidth">
                    <el-select v-model="saveForm.appId" filterable>
                        <el-option
                            v-for="item in this.enum"
                            :key="item.appId"
                            :label="item.appName"
                            :value="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {appAll, deleteRule, queryRule, saveRule} from '@/http/api'
import app from "@/App.vue";
import {dateTimeFormat} from "@/filters";

export default {
    name: "AttributionRule",
    computed: {
        app() {
            return app
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '330px',
            list: [],
            enum: [],
            saveForm: {
                id: null,
                appId: null,
                advertiserIds: null,
                agentId: null,
                lcName: null,
                maxEcpm: null,
                ecpm: null,
                ltv: null,
                ltva: null,
                ads: null,
                adsa: null,
                ecpmr1: null,
                ltvr1: null,
                adsr1: null,
                adsv: null,
                ecpmv: null,
                ecpma: null,
                adsi: null,
                ecpmi: null,
                adss: null,
                ecpms: null,
                maxEcpmv: null,
                maxEcpmi: null,
                maxEcpms: null,
                rule: null,
                acRule: null,
                akey: null
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {},
            ruleEnum: {
                1: "双出价",
                2: "关键行为"
            },
            acRuleEnum: {
                1: "归因激活",
                2: "广告激活"
            }
        }
    },
    methods: {
        jump() {
            this.$router.push({path: '/watchLinkedUrl'});
        },
        cell({columnIndex}) {
            if (columnIndex > 1 && columnIndex < 5) {
                return "background-color:#FFCCCC"
            }
            if (columnIndex > 4 && columnIndex < 15) {
                return "background-color:#CCFFCC"
            }

        },
        dateTimeFormat,
        enumFormatter: function (row, column, cellValue) {
            let temp = ""
            this.enum.forEach(item => {
                if (item.appId === cellValue) {
                    temp = item.appName;
                }
            })
            return temp
        },
        ruleFormatter: function (row, column, cellValue) {
            return this.ruleEnum[cellValue]
        },
        acRuleFormatter: function (row, column, cellValue) {
            return this.acRuleEnum[cellValue]
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.getList();
        },
        getList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            queryRule(this.queryData).then(resp => {
                this.list = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        remove(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteRule(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.getList();
                    }
                });
            }).catch(() => {
            })
        },
        showSaveFormDialog(_title, _data) {
            this.dialogVisible = true;
            this.dialogTitle = _title;
            this.saveForm = {
                id: null,
                appId: null,
                advertiserIds: null,
                maxEcpm: null,
                ecpm: null,
                ltv: null,
                ltva: null,
                agentId: null,
                lcName: null,
                ads: null,
                adsa: null,
                ecpmr1: null,
                ltvr1: null,
                adsr1: null,
                ecpmv: null,
                adsv: null,
                ecpmi: null,
                adsi: null,
                ecpms: null,
                ecpma: null,
                adss: null,
                maxEcpmv: null,
                maxEcpmi: null,
                maxEcpms: null,
                akey: null,
                rule: null,
                acRule: null,
            };
            if (_data) {
                this.saveForm = {
                    id: _data.id,
                    appId: _data.appId,
                    advertiserIds: _data.advertiserIds,
                    maxEcpm: _data.maxEcpm,
                    ecpm: _data.ecpm,
                    ecpma: _data.ecpma,
                    agentId: _data.agentId,
                    lcName: _data.lcName,
                    ltv: _data.ltv,
                    ltva: _data.ltva,
                    ads: _data.ads,
                    adsa: _data.adsa,
                    ecpmr1: _data.ecpmr1,
                    ltvr1: _data.ltvr1,
                    adsr1: _data.adsr1,
                    ecpmv: _data.ecpmv,
                    adsv: _data.adsv,
                    ecpmi: _data.ecpmi,
                    adsi: _data.adsi,
                    ecpms: _data.ecpms,
                    adss: _data.adss,
                    maxEcpmv: _data.maxEcpmv,
                    maxEcpmi: _data.maxEcpmi,
                    maxEcpms: _data.maxEcpms,
                    akey: _data.akey,
                    rule: _data.rule,
                    acRule: _data.acRule,
                }
            }
        },
        confirmForm() {
            this.save(this.saveForm);
        },
        save(data) {
            saveRule(data).then(resp => {
                if (resp.data.status === 0) {
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }

    },
    created() {
        this.getList();
        appAll().then(resp => {
            this.enum = resp.data.info;
        });
    }
}
</script>